const provincias = [
  { nombre: "BUENOS AIRES", sisa: "Buenos Aires", recipe: "BUENOS AIRES" },
  { nombre: "CATAMARCA", sisa: "Catamarca", recipe: "CATAMARCA" },
  { nombre: "CHACO", sisa: "Chaco", recipe: "CHACO" },
  { nombre: "CHUBUT", sisa: "Chubut", recipe: "CHUBUT" },
  { nombre: "CIUDAD AUTONOMA DE BS AS", sisa: "CABA", recipe: "CIUDAD AUTONOMA DE BS AS" },
  { nombre: "CORDOBA", sisa: "Córdoba", recipe: "CORDOBA" },
  { nombre: "CORRIENTES", sisa: "Corrientes", recipe: "CORRIENTES" },
  { nombre: "ENTRE RIOS", sisa: "Entre Ríos", recipe: "ENTRE RIOS" },
  { nombre: "FORMOSA", sisa: "Formosa", recipe: "FORMOSA" },
  { nombre: "JUJUY", sisa: "Jujuy", recipe: "JUJUY" },
  { nombre: "LA PAMPA", sisa: "La Pampa", recipe: "LA PAMPA" },
  { nombre: "LA RIOJA", sisa: "La Rioja", recipe: "LA RIOJA" },
  { nombre: "MENDOZA", sisa: "Mendoza", recipe: "MENDOZA" },
  { nombre: "MISIONES", sisa: "Misiones", recipe: "MISIONES" },
  { nombre: "NEUQUEN", sisa: "Neuquén", recipe: "NEUQUEN" },
  { nombre: "RIO NEGRO", sisa: "Río Negro", recipe: "RIO NEGRO" },
  { nombre: "SALTA", sisa: "Salta", recipe: "SALTA" },
  { nombre: "SAN JUAN", sisa: "San Juan", recipe: "SAN JUAN" },
  { nombre: "SAN LUIS", sisa: "San Luis", recipe: "SAN LUIS" },
  { nombre: "SANTA CRUZ", sisa: "Santa Cruz", recipe: "SANTA CRUZ" },
  { nombre: "SANTA FE", sisa: "Santa Fe", recipe: "SANTA FE" },
  { nombre: "SANTIAGO DEL ESTERO", sisa: "Santiago del Estero", recipe: "SANTIAGO DEL ESTERO" },
  { nombre: "TIERRA DEL FUEGO", sisa: "Tierra Del Fuego", recipe: "TIERRA DEL FUEGO" },
  { nombre: "TUCUMAN", sisa: "Tucumán", recipe: "TUCUMAN" },
];

export default provincias;
